/* eslint-disable */

// Para mais casos, olhar em:
// https://github.com/ng-chicago/AddToHomeScreen/blob/12a7c94a110a19bb925f4c0c8b5513b76c41a90f/src/app/a2hs.service.ts

export function hasStandalone() {
  return (window.matchMedia('(display-mode: standalone)').matches);
}
